<template>
  <div :class="$style.container">
    <BaseHeading size="h4" :class="$style.title">
      {{ data?.fields?.title }}
    </BaseHeading>

    <MarkedParser class="u-type-p2" :md="data?.fields?.copy" />

    <CallToAction :class="$style.cta" :cta="data?.fields?.cta" />
  </div>
</template>

<script setup lang="ts">
import type { TypeAsideCardWithoutUnresolvableLinksResponse } from '~/types/contentful'

defineProps<{
  data: TypeAsideCardWithoutUnresolvableLinksResponse
}>()
</script>

<style lang="scss" module>
.container {
  padding: 0 20px 32px;
  position: relative;
  z-index: 1;
  @include fluid-type(21px, 23px);
}

.title {
  font-family: var(--roboto-condensed);
  line-height: math.div(28, 23);
}

.cta {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 145px;
  margin: 19px auto auto;
  height: 50px;
}
</style>
